import { Routes } from '@angular/router';
import { IssueExplorerPageComponent } from './pages/issues/issue-explorer-page.component';
import { OverviewPageComponent } from './pages/overview/overview-page.component';
import { RepositoriesPageComponent } from './pages/repositories/repositories-page.component';
import { RepositoryDetailPageComponent } from './pages/repositories/repository-detail-page.component';
import { DevelopersPageComponent } from './pages/developers/developers-page.component';
import { TrendsPageComponent } from './pages/trends/trends-page.component';
import { HotspotsPageComponent } from './pages/hotspots/hotspots-page.component';
import { RecurringIssuesPageComponent } from './pages/recurring-issues/recurring-issues-page.component';
import { SignalsPageComponent } from './pages/signals/signals-page.component';
import { OperationsPageComponent } from './pages/operations/operations-page.component';
import { RulesPageComponent } from './pages/rules/rules-page.component';
import { NoAccessPageComponent } from './pages/no-access/no-access-page.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'overview' },
  { path: 'no-access', component: NoAccessPageComponent },
  { path: 'overview', component: OverviewPageComponent, canActivate: [authGuard] },
  { path: 'repositories', component: RepositoriesPageComponent, canActivate: [authGuard] },
  { path: 'repositories/:id', component: RepositoryDetailPageComponent, canActivate: [authGuard] },
  { path: 'issues', component: IssueExplorerPageComponent, canActivate: [authGuard] },
  { path: 'developers', component: DevelopersPageComponent, canActivate: [authGuard] },
  { path: 'trends', component: TrendsPageComponent, canActivate: [authGuard] },
  { path: 'hotspots', component: HotspotsPageComponent, canActivate: [authGuard] },
  { path: 'recurring-issues', component: RecurringIssuesPageComponent, canActivate: [authGuard] },
  { path: 'signals', component: SignalsPageComponent, canActivate: [authGuard] },
  { path: 'operations', component: OperationsPageComponent, canActivate: [authGuard] },
  { path: 'rules', component: RulesPageComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: 'overview' },
];
